import { Flex, UnstyledButton } from "@mantine/core";
import { ISectionWithItems } from "@mctypes/frontend.types";
import { IValueLabel } from "@mctypes/global.types";
import "./tabsidebar.css";

const TabSidebar: React.FC<{
  sections: ISectionWithItems[];
  activeTab: string;
  onClick: (arg: IValueLabel) => void;
  collapsed?: boolean;
}> = ({ activeTab, sections, onClick, collapsed }) => {
  const TabSection: React.FC<{ section: ISectionWithItems }> = ({ section }) => {
    const tabSection = section.items.map((item) => {
      return (
        (item.showItem === undefined || item.showItem) && (
          <UnstyledButton
            key={item.value}
            type="button"
            fz="1em"
            className={`sidebar-tab ${item.value === activeTab ? "active" : ""}`}
            onClick={() => onClick(item)}
          >
            <div>{item.label}</div>
          </UnstyledButton>
        )
      );
    });
    return <>{tabSection}</>;
  };
  const allSections = sections.map((section) => {
    return (
      <div key={section.label}>
        <div className="font-weight-bold ml-2 mt-3" style={{ fontSize: "1.1rem", color: "#4e4e4e" }}>
          {section.label}
        </div>
        <TabSection section={section} key={section.label} />
      </div>
    );
  });

  return (
    <Flex
      bg={"lightgray.0"}
      className={`settingsSidebar overflow-hidden ${collapsed ? "settingsSidebar-collapsed" : ""}`}
      direction="column"
    >
      {allSections}
    </Flex>
  );
};

export default TabSidebar;
